// Internal

import { ModalName } from '../services/_app/bootstrap-modal/modal-values.service';
import { MODULE_PATHS } from '../services/_app/language/language.service';

export interface ModalProperties {
    activated: boolean;
    modalActivated: ModalName | null;
    modalOpening: boolean;
    isAnimating: boolean;
};

export class ModalContainerOptions {
    // size?: ModalSize = ModalSize.MD;
    backdropDismissable?: boolean = true;
    buttonDismissable?: boolean = true;
    exceptionClass?: string;
    isFlow?: boolean = false;
    useShellFooter?: boolean = false;
    // reverseAnimation?: boolean = false;
};

export interface ModalContentOptions extends ModalContentOptionsError {
    scenario?: string,
    alreadyActive?: boolean,
    trial?: boolean,
    currentStep?: string,
    flow?: string;
    isOnboardingFlow?: boolean,
    skipRedirectAtClose?: boolean,
    type?: string,
    user?: any,
    project?: any,
    contact?: any,
    tenantId?: any,
    organisation?: any,
    selectedFile?: any,
    interventionId?: any,
    files?: any[],
    feedback?: any,
    feedbackId?: any,
    tenantContract?: any,
    agentId?: any,
    buildingReportId?: any,
    permitId?: any,
    offerId?: any,
    offer?: any,
    invoiceId?: any,
    projectId?: any,
    leadId?: any,
    leadName?: string,
    leadStatusId?: any,
    budgetId?: any,
    quality?: any,
    qualityId?: any,
    dimension?: any,
    dimensionId?: any,
    product?: any,
    pipeId?: any,
    client?: any,
    requestId?: any,
    rfqId?: any,
    rfqName?: string,
    mode?: string,
    rfq?: any
};

export interface ModalContentOptionsError {
    inviteId?: number,
    groupId?: number,
    trialId?: number,
    meter?: any,
    equipment?: any,
    spaceId?: any,
    supplier?: any,
    buildingReportId?: any,
    permitId?: any
};

// export enum ModalSize {
//     /** width: 440px */
//     SM = 'sm',
//     /** width: 600px */
//     MD = 'md',
//     .....etc.....
//     AUTO = 'auto'
// };

export interface AllModalInformation {
    moduleName: MODULE_PATHS
    name: ModalName,
    title?: string,
    containerOptions: ModalContainerOptions,
    contentOptions?: ModalContentOptions,
    options?: object,
    callback?: (result?: any) => void
};

export type ModalNamesToPaths = {
    [key in MODULE_PATHS]?: {
        [key in ModalName]?: () => Promise<object>
    }
}
